import { Storie } from 'types/InputsStoriesCarouselProps';
import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';

export function verifyIfFormCanSave(dataForm: Storie, handleNotify: any) {
	if (dataForm.title === '') {
		handleNotify('Preenha o campo "Título"', 'error');
		return false;
	}

	if (dataForm.redirect.type === '') {
		handleNotify('Preencha o tipo do redirecionamento', 'error');
		return false;
	}

	if (dataForm.redirect.value === '') {
		handleNotify('Preencha o valor do redirecionameto', 'error');
		return false;
	}

	if (dataForm.image === null) {
		handleNotify('Suba a imagem do banner', 'error');
		return false;
	}

	return true;
}

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.slug, option: item.name });
	});

	return listOptions;
}
